import { Context, Layer, type Cause, type Effect, type Scope } from "effect";
import type { PanelKeyboardFocusFailure, PanelKeyboardRequest } from "./panel-keyboard-model.ts";

export class PanelKeyboardFocusIo extends Context.Service<PanelKeyboardFocusIo, {
  readonly focus: (container: HTMLElement, host: HTMLElement, request: PanelKeyboardRequest, preventDefault: () => void) => Effect.Effect<unknown, PanelKeyboardFocusFailure>;
}>()("workerstation/frontend/PanelKeyboardFocusIo") {}
export const PanelKeyboardFocusIoTest = (io: typeof PanelKeyboardFocusIo.Service) => Layer.succeed(PanelKeyboardFocusIo, io);
export interface PanelKeyboardFocusSession {
  readonly focus: (container: HTMLElement | null, host: HTMLElement | null, request: unknown, preventDefault: () => void) => Effect.Effect<void>;
}
export class PanelKeyboardFocus extends Context.Service<PanelKeyboardFocus, {
  readonly open: (current: (container: HTMLElement, host: HTMLElement) => unknown) => Effect.Effect<PanelKeyboardFocusSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<PanelKeyboardFocusFailure>[]>;
}>()("workerstation/frontend/PanelKeyboardFocus") {}
